import { useEffect, useState } from 'react';
import api from '../../api/axios';

const EMPTY = { question: '', answer: '', category: 'General', sort_order: 0 };
const CATEGORIES = ['Membership', 'Events', 'Community', 'General', 'Other'];

export default function FaqManager() {
  const [faqs, setFaqs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [form, setForm] = useState(EMPTY);
  const [editing, setEditing] = useState(null);
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState('');
  const [showForm, setShowForm] = useState(false);

  const load = () => {
    setLoading(true);
    api.get('/faq').then(r => setFaqs(r.data || [])).finally(() => setLoading(false));
  };

  useEffect(() => { load(); }, []);

  const handle = e => setForm(f => ({ ...f, [e.target.name]: e.target.value }));
  const openAdd = () => { setEditing(null); setForm(EMPTY); setError(''); setShowForm(true); };
  const openEdit = f => { setEditing(f.id); setForm({ question: f.question, answer: f.answer, category: f.category || 'General', sort_order: f.sort_order || 0 }); setError(''); setShowForm(true); };

  const save = async (e) => {
    e.preventDefault();
    setSaving(true);
    setError('');
    try {
      if (editing) await api.put(`/faq/${editing}`, form);
      else await api.post('/faq', form);
      setShowForm(false);
      load();
    } catch (err) {
      setError(err.response?.data?.error || 'Save failed');
    } finally {
      setSaving(false);
    }
  };

  const remove = async (id) => {
    if (!window.confirm('Delete this FAQ?')) return;
    await api.delete(`/faq/${id}`);
    load();
  };

  return (
    <div>
      <div className="d-flex align-items-center justify-content-between mb-4">
        <div><h4 className="fw-bold mb-0">FAQ</h4><p className="text-muted small mb-0">Manage frequently asked questions</p></div>
        <button className="btn btn-primary rounded-pill px-4" onClick={openAdd}><i className="fas fa-plus me-2"></i>Add FAQ</button>
      </div>

      {showForm && (
        <div className="card border-0 shadow-sm mb-4">
          <div className="card-body p-4">
            <h5 className="fw-bold mb-4">{editing ? 'Edit FAQ' : 'Add FAQ'}</h5>
            {error && <div className="alert alert-danger py-2">{error}</div>}
            <form onSubmit={save}>
              <div className="row g-3">
                <div className="col-md-8"><label className="form-label small">Question *</label><input name="question" value={form.question} onChange={handle} required className="form-control" /></div>
                <div className="col-md-4">
                  <label className="form-label small">Category</label>
                  <select name="category" value={form.category} onChange={handle} className="form-select">
                    {CATEGORIES.map(c => <option key={c}>{c}</option>)}
                  </select>
                </div>
                <div className="col-12"><label className="form-label small">Answer *</label><textarea name="answer" value={form.answer} onChange={handle} required rows="4" className="form-control"></textarea></div>
                <div className="col-md-4"><label className="form-label small">Display Order</label><input name="sort_order" type="number" value={form.sort_order} onChange={handle} className="form-control" /></div>
              </div>
              <div className="d-flex gap-2 mt-4">
                <button type="submit" disabled={saving} className="btn btn-primary rounded-pill px-4">{saving ? 'Saving...' : 'Save'}</button>
                <button type="button" className="btn btn-outline-secondary rounded-pill px-4" onClick={() => setShowForm(false)}>Cancel</button>
              </div>
            </form>
          </div>
        </div>
      )}

      {loading ? <div className="text-center py-5"><div className="spinner-border text-primary"></div></div> : (
        <div className="card border-0 shadow-sm">
          <div className="table-responsive">
            <table className="table table-hover mb-0">
              <thead className="table-light"><tr><th>Question</th><th>Category</th><th>Order</th><th></th></tr></thead>
              <tbody>
                {faqs.length === 0 && <tr><td colSpan="4" className="text-center text-muted py-4">No FAQs yet.</td></tr>}
                {faqs.map(f => (
                  <tr key={f.id}>
                    <td>{f.question}</td>
                    <td><span className="badge badge-soft-primary">{f.category}</span></td>
                    <td>{f.sort_order}</td>
                    <td>
                      <button className="btn btn-sm btn-outline-primary me-2" onClick={() => openEdit(f)}>Edit</button>
                      <button className="btn btn-sm btn-outline-danger" onClick={() => remove(f.id)}>Delete</button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      )}
    </div>
  );
}
